import Spin from './spin'
export * from './spin'
export default Spin
